import { render, staticRenderFns } from "./InteresCreate.vue?vue&type=template&id=0745a1a9&scoped=true"
import script from "./InteresCreate.vue?vue&type=script&lang=js"
export * from "./InteresCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745a1a9",
  null
  
)

export default component.exports